import {Ziggy} from '@/js/ziggy';
import route from '../../../../vendor/tightenco/ziggy/src/js/route';

export default function appRouter(name, params) {
    return route(name, params, false, Ziggy);
}

appRouter.install = function (Vue) {
    Vue.prototype.$toRoute = appRouter;
};
